export default "__VITE_ASSET__453fd7c5__"